export default __webpack_public_path__ + "static/media/long.a5aff691.svg";